<template>
  <main class="page-content">
    <div class="page-content__head">
      <div class="container-fluid">
        <h1 class="page-content__title">Список транспортных средств</h1>
      </div>
    </div>


    <div class="container-fluid">

      <div class="row">

        <div class="page-content__filter">

          <div class="form">

            <div class="form__group">
              <label class="label  label--block" for="requestData">Значение</label>
              <input v-model="requestData" class="field" type="text" id="requestData" autocomplete="off">
            </div>

            <div class="form__group  checkbox-group">
              <div class="label  label--block" for="">Статус</div>

              <label class="checkbox">
                <input v-model="statusInspected" class="checkbox__input" type="checkbox" name="statusInspected">
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label">Произведен осмотр</span>
              </label>

              <label class="checkbox">
                <input v-model="statusExecuted" class="checkbox__input" type="checkbox" name="statusExecuted">
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label">Произведена регистрация</span>
              </label>
            </div>

            <div class="form__group">
              <label class="label  label--block">Дата осмотра</label>
              <div class="form__tillfrom-row">

                <date-picker
                  format="DD.MM.YYYY"
                  value-type="YYYY-MM-DD"
                  class="form__tillfrom-col  flex-grow-1"
                  input-class="field"
                  v-model="dateFrom"/>

                <div class="form__tillfrom-sep"></div>

                <date-picker
                  format="DD.MM.YYYY"
                  value-type="YYYY-MM-DD"
                  class="form__tillfrom-col  flex-grow-1"
                  input-class="field"
                  v-model="dateTo"/>

              </div>
            </div>

            <div class="form__submit">
              <a class="btn  btn--main  btn--full-width"
                 :class="{ 'btn--disabled': (!this.dateFrom && !this.dateTo && !this.requestData && !this.statusInspected && !this.statusExecuted ) }"
                 @click="fetchInspections(1)" href="javascript:void(0);">Отфильтровать</a>
              <a class="btn  btn--main-outline  btn--full-width"
                 :class="{ 'btn--disabled': (!this.dateFrom && !this.dateTo && !this.requestData && !this.statusInspected && !this.statusExecuted ) }"
                 @click="clearForm" href="javascript:void(0);">Сбросить значения</a>
            </div>

          </div>
          <!-- /.form -->

        </div>
        <!-- /.page-content__filter -->


        <!-- search results -->
        <div class="col">

          <div class="section">

            <div class="section__header">

              <div class="row  align-items-baseline">

                <div class="col-12  d-flex  justify-content-end">
                  <div class="section__view">
                    <div class="label">Опции показа</div>

                    <select v-model="pageSize" v-on:change="fetchInspections(1)"
                            class="section__view-toggler  field  field--select" name="" id="viewOptions">
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                </div>

              </div>

            </div>
            <!-- /.section__header -->

            <div class="section__body">

              <table class="table-items">

                <thead class="table-items__head">
                <tr>
                  <td class="table-items__hcell" width="16px"></td>
                  <td class="table-items__hcell"><h5>Транспорт</h5></td>
                  <td class="table-items__hcell"><h5>Оператор</h5></td>
                  <td class="table-items__hcell"><h5>Дата осмотра</h5></td>
                  <td class="table-items__hcell"><h5>Статус</h5></td>
                </tr>
                </thead>

                <tbody class="table-items__body">

                <!-- TABLE ITEM -->

                <template v-for="inspection in this.allInspections">

                  <tr :key="inspection.uuid" @click="clickTable(inspection.uuid)" class="table-items__row"
                      :class="{'table-items__row-triggered': (inspection.uuid == selectedInspect)}">
                    <td class="table-items__cell">
                      <svg class="table-items__toggle-icon">
                        <use xlink:href="#icon__arrow-right"></use>
                      </svg>
                    </td>

                    <td class="table-items__cell">
                      <div class="table-items__title">{{ inspection.requestData }}</div>
                      <div class="table-items__descr">{{ inspection.requestType }}</div>
                    </td>

                    <td class="table-items__cell">
                      {{ inspection.operatorName }}
                      <div class="table-items__descr">{{ inspection.operatorState }}</div>
                    </td>

                    <td class="table-items__cell">
                      {{ new Date(inspection.inspectedDate).format('d.m.Y H:i') }}
                      <div v-if="inspection.executedDate" class="table-items__descr">{{ new
                        Date(inspection.executedDate).format('d.m.Y H:i') }}
                      </div>
                    </td>

                    <td class="table-items__cell">

                      <div class="badge  badge--success">Осмотр</div>
                      <div v-if="inspection.status == 4" class="badge  badge--primary" style="margin-left: 10px;">
                        Регистрация
                      </div>

                    </td>
                  </tr>


                  <tr v-if="inspection.uuid == selectedInspect" class="table-items__hidden-content  table-items__hidden-content--expanded">
                    <td class="table-items__cell"></td>

                    <td class="table-items__cell" colspan="5">

                      <div class="row  mb-2  pb-1">

                        <div class="col-6">

                          <section class="tabs">

                            <ul class="nav  tabs__nav  tabs__hor-nav">
                              <li class="tabs__nav-item">
                                <a class="tabs__nav-link active" data-toggle="tab" href="#logs">Логи</a>
                              </li>
                            </ul>


                            <div class="tabs__content  tabs__content--bg-white">

                              <div id="logs" class="tabs__pane  active">
                                <table class="table  table--noborder">
                                  <thead class="table__head">
                                  <tr class="table__row">
                                    <th class="table__hcell" style="width: 30%;">Дата</th>
                                    <th class="table__hcell" style="width: 70%;">Действие</th>
                                  </tr>
                                  </thead>

                                  <tbody class="table__body">
                                  <tr v-if="inspection.findDate" class="table__row">
                                    <td class="table__cell">{{ new Date(inspection.findDate).format('d.m.Y H:i') }}</td>
                                    <td class="table__cell">Поиск транспорта</td>
                                  </tr>

                                  <tr v-if="inspection.inspectedDate" class="table__row">
                                    <td class="table__cell">{{ new Date(inspection.inspectedDate).format('d.m.Y H:i') }}</td>
                                    <td class="table__cell">Произведен осмотр <span v-if="inspection.expertise">с экспертизой</span></td>
                                  </tr>

                                  <tr v-if="inspection.executedDate" class="table__row">
                                    <td class="table__cell">{{ new Date(inspection.executedDate).format('d.m.Y H:i') }}</td>
                                    <td class="table__cell">Произведена регистрация</td>
                                  </tr>

                                  </tbody>
                                </table>
                              </div>

                            </div>
                            <!-- /tabs__content -->

                          </section>
                          <!-- /.tabs -->

                        </div>
                        <!-- /.col-9 -->

                        <div class="col-6">
                          <CoolLightBox
                            :items="resultPhotos"
                            :index="index"
                            loop
                            @close="index = null">
                          </CoolLightBox>

                          <div class="images-wrapper images-wrapper-divs">
                            <div
                              class="image"
                              v-for="(image, imageIndex) in resultPhotos"
                              :key="imageIndex"
                              @click="setIndex(imageIndex)"
                              :style="{ backgroundImage: 'url(' + image.src + ')' }"
                            ></div>
                          </div>

                          <div class="images-wrapper images-wrapper-img">
                            <img
                              class="imageItem"
                              v-for="(image, imageIndex) in resultPhotos"
                              :key="imageIndex"
                              @click="setIndex(imageIndex)"
                              :src="image.src"
                            />
                          </div>
                        </div>

                      </div>
                      <!-- /.row -->

                    </td>
                  </tr>

                </template>

                <!-- / TABLE ITEM -->


                </tbody>

              </table>

            </div>
            <!-- /.section__body -->

            <div class="section__footer">

              <div class="row">

                <div class="col-6">
                  <div class="section__descr">Найдено осмотров: {{ inspectionTotalCount }}</div>
                </div>

                <!-- pagination -->
                <div class="col-6  d-flex  justify-content-end">

                  <div v-if="this.inspectionPageTotal" class="mypagination">

                    <ul class="mypagination__list">

                      <li class="mypagination__item  mypagination__arrow"
                          :class="{ 'mypagination__item-disabled': this.inspectionIsFirstPage }">
                        <a @click="fetchInspections(1)" class="mypagination__link" href="javascript:void(0);">
                          <svg class="mypagination__icon">
                            <use xlink:href="#icon__arrow-left"></use>
                          </svg>
                        </a>
                      </li>

                      <template v-if="this.inspectionCurrentPage > 3">
                        <li class="mypagination__item">
                          <a @click="fetchInspections(1)" class="mypagination__link" href="javascript:void(0);">1</a>
                        </li>

                        <li class="mypagination__item  mypagination__dots">...</li>
                      </template>

                      <li v-if="(this.inspectionCurrentPage - 2) > 0" class="mypagination__item">
                        <a @click="fetchInspections(inspectionCurrentPage - 2)" class="mypagination__link"
                           href="javascript:void(0);">{{ this.inspectionCurrentPage - 2 }}</a>
                      </li>

                      <li v-if="(this.inspectionCurrentPage - 1) > 0" class="mypagination__item">
                        <a @click="fetchInspections(inspectionCurrentPage - 1)" class="mypagination__link"
                           href="javascript:void(0);">{{ this.inspectionCurrentPage - 1 }}</a>
                      </li>

                      <li class="mypagination__item  mypagination__item-active">
                        <a class="mypagination__link" href="javascript:void(0);">{{ this.inspectionCurrentPage }}</a>
                      </li>

                      <li v-if="(this.inspectionCurrentPage + 1 ) < this.inspectionPageTotal + 1"
                          class="mypagination__item">
                        <a @click="fetchInspections(inspectionCurrentPage + 1)" class="mypagination__link"
                           href="javascript:void(0);">{{ this.inspectionCurrentPage + 1 }}</a>
                      </li>

                      <li v-if="(this.inspectionCurrentPage + 2 ) < this.inspectionPageTotal + 1"
                          class="mypagination__item">
                        <a @click="fetchInspections(inspectionCurrentPage + 2)" class="mypagination__link"
                           href="javascript:void(0);">{{ this.inspectionCurrentPage + 2 }}</a>
                      </li>

                      <template v-if="this.inspectionCurrentPage < this.inspectionPageTotal - 2">
                        <li class="mypagination__item  mypagination__dots">...</li>

                        <li class="mypagination__item">
                          <a @click="fetchInspections(inspectionPageTotal)" class="mypagination__link"
                             href="javascript:void(0);">{{ this.inspectionPageTotal }}</a>
                        </li>
                      </template>

                      <li class="mypagination__item  mypagination__arrow"
                          :class="{ 'mypagination__item-disabled': this.inspectionIsLastPage }">
                        <a @click="fetchInspections(inspectionPageTotal)" class="mypagination__link"
                           href="javascript:void(0);">
                          <svg class="mypagination__icon">
                            <use xlink:href="#icon__arrow-right"></use>
                          </svg>
                        </a>
                      </li>

                    </ul>
                  </div>

                </div>
                <!-- /.mypagination -->

              </div>
              <!-- /.row -->

            </div>
            <!-- /.section__footer -->

          </div>
          <!-- /.section -->

        </div>
        <!-- / search results -->

      </div>
      <!-- /.row -->

    </div>
    <!-- /.container-fluid -->
  </main>

</template>

<script>
  import {mapGetters} from 'vuex'
  import '../assets/js/date.format'

  import CoolLightBox from 'vue-cool-lightbox'
  import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';

  export default {
    name: 'Inspected-List',
    data() {
      return {
        isLoading: false,
        pageSize: 10,
        requestData: null,
        dateFrom: null,
        dateTo: null,
        statusInspected: null,
        statusExecuted: null,
        resultData: [],
        selectedInspect: null,
        resultPhotos: [],
        index: null
      }
    },
    computed: mapGetters([
      'allInspections',
      'inspectionTotalCount',
      'inspectionPageTotal',
      'inspectionCurrentPage',
      'inspectionIsFirstPage',
      'inspectionIsLastPage',
    ]),
    methods: {
      async fetchInspections(page = 1) {
        const data = {
          'pageSize': this.pageSize,
          'requestData': this.requestData,
          'dateFrom': this.dateFrom,
          'dateTo': this.dateTo,
          'statusInspected': this.statusInspected,
          'statusExecuted': this.statusExecuted
        };

        Object.keys(data).forEach((key) => (data[key] == null) && delete data[key])

        await this.fetchPost('/adm/data/inspections?page=' + page, data, 'resultData');
        this.$store.commit('updateInspections', this.resultData);
      },
      clearForm() {
        this.requestData = null;
        this.dateFrom = null;
        this.dateTo = null;
        this.statusInspected = null;
        this.statusExecuted = null;

        this.fetchInspections(1);
      },
      clickTable(uuid) {
        this.resultPhotos = [];

        if (this.selectedInspect === uuid) {
          this.selectedInspect = null;
        } else {
          this.selectedInspect = uuid;
          this.fetchPhotos(uuid);
        }
      },
      async fetchPhotos(uuid) {
        await this.fetchPost('/adm/data/photos', {
          'requestUuid': uuid
        }, 'resultPhotos');
      },
      setIndex(index) {
        this.index = index
      }
    },
    mounted() {
      this.fetchInspections();
    },
    components: {
      DatePicker, CoolLightBox
    }
  }

</script>

<style>
  .imageItem {
    width: 150px;
    margin: 15px;
    cursor:pointer;
  }
</style>
